import { connect as globalConnect } from 'react-redux';

// We want to keep the arity of the original mapStateToProps, because connect
// optimizes based on the accepted params.
const focusEditorState = (slice, mapStateToProps) => {
  if (!mapStateToProps || !mapStateToProps.length) return mapStateToProps;
  if (mapStateToProps.length === 1)
    return state => mapStateToProps(state[slice]);
  if (mapStateToProps.length === 2)
    return (state, props) => mapStateToProps(state[slice], props);
  return (state, ...rest) => mapStateToProps(state[slice], ...rest);
};

const connect = (slice, mapStateToProps, ...rest) =>
  globalConnect(focusEditorState(slice, mapStateToProps), ...rest);

export default connect;
